import type { AppState } from 'types/app';

export const getIsLiveChatEnabled = (state: AppState) => {
  const { holmes, killswitch } = state || {};
  const { enableLiveChatForSoftAuthOnly = false, disableLiveChat = false } = killswitch;
  const isEnabledForSoftAuth = enableLiveChatForSoftAuthOnly ? Boolean(holmes) : true;

  return disableLiveChat ? false : isEnabledForSoftAuth;
};
